const actionTypeIdentifier = '3AB06B3C-F8C5-433E-AE79-62B98DFAF22F';

export const getInvoiceNumber = `DISPUTE-GET-INVOICE-NUMBER-${actionTypeIdentifier}`;
export const getBilledCircuitId = `DISPUTE-GET-BILLED-CIRCUIT-ID-${actionTypeIdentifier}`;
export const getMatchedCircuitId = `DISPUTE-GET-MATCHED-CIRCUIT-ID-${actionTypeIdentifier}`;
export const disableMatchedCircuitId = `DISPUTE-DISABLE-MATCHED-CIRCUIT-ID-${actionTypeIdentifier}`;
export const getDisputeType = `DISPUTE-GET-DISPUTE-TYPE-ID-${actionTypeIdentifier}`;
export const getDisputeStatus = `DISPUTE-GET-DISPUTE-STATUS-ID-${actionTypeIdentifier}`;
export const disableBilledCircuitId = `DISPUTE-DISABLE-BILLED-CIRCUIT-ID-${actionTypeIdentifier}`;
export const requireBilledCircuitId = `DISPUTE-REQUIRE-BILLED-CIRCUIT-ID-${actionTypeIdentifier}`;
export const fetchDisputeDetails = `DISPUTE-FETCH-DISPUTE-DETAILS-${actionTypeIdentifier}`;

export const disputeDetailsFormModel = {
    id: 0,
    disputeId: null,
    disputeType: null,
    disputeStatus: null,
    createdBy: null,
    invoiceNumber: null,
    invoiceNumberDisplay: '',
    accountNumber: null,
    vendor: null,
    country: null,
    invoiceDate: null,
    actualInvoiceMonth: null,
    billedCircuitId: null,
    billedCircuitIdDisplay: '',
    amountCharged: null,
    matchedCircuitId: null,
    matchedCircuitIdDisplay: '',
    mrc: null,
    potentialSavings: '0.00',
    annualPotentialSavings: '0.00',
    realizedSavings: '0.00',
    annualRealizedSavings: '0.00',
    dateCreated: null,
    submittedToVendorDate: null,
    vendorConfirmationDate: null,
    expectedResolutionDate: null,
    completedDate: null,
    creditReceivedDate: null,
    additionalInformation: null
};